import { ChevronRight } from "@mui/icons-material";

import { Header } from "@baseComponents/Header";
import { useMediaQueryBreakpoint } from "@hooks";

import {
  CTAButton,
  WrapperWithLines,
  CTAContainer,
  Line,
  LinesContainer,
  CTALink,
} from "./styles.styled";

export interface CTAContent {
  buttonText: string;
  header?: string;
  subheader?: string;
}

interface CTAProps extends CTAContent {
  className?: string;
}

export const CTA = ({ buttonText, header, subheader, className }: CTAProps) => {
  const { isTablet } = useMediaQueryBreakpoint();

  return (
    <CTAContainer className={className}>
      {header && (
        <Header header={header} subheader={subheader} headerIsSecondary />
      )}

      <WrapperWithLines>
        {isTablet && (
          <LinesContainer>
            <Line linePosition="center" side="left" />

            <Line linePosition="end" side="left" />

            <Line linePosition="start" side="left" />
          </LinesContainer>
        )}

        <CTALink href="/contact" passHref>
          <CTAButton
            variant="contained"
            disableElevation
            endIcon={<ChevronRight />}
          >
            {buttonText}
          </CTAButton>
        </CTALink>

        {isTablet && (
          <LinesContainer>
            <Line linePosition="end" side="right" />

            <Line linePosition="start" side="right" />

            <Line linePosition="center" side="right" />
          </LinesContainer>
        )}
      </WrapperWithLines>
    </CTAContainer>
  );
};
